<nav
  mat-tab-nav-bar
  class="container tabs-container"
>
  <a
    mat-tab-link
    *ngFor="let link of navLinks; let i = index;"
    [routerLink]="basePath + link.path"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="rla.isActive"
  >
    {{ 'pages.downtown_life.title' + (i + 1) | translate }}
  </a>
</nav>

<router-outlet></router-outlet>

<app-contact-us
  [component]="'downtown_life'"
>
</app-contact-us>



// WEBPACK FOOTER //
// ./src/app/downtown-life/downtown-life.component.html